import { render, staticRenderFns } from "./IconGlobeOutline.vue?vue&type=template&id=48a26761"
import script from "./IconGlobeOutline.vue?vue&type=script&lang=js"
export * from "./IconGlobeOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports